import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const OrdersRoutes = [
    {
        path: '/orders',
        component: () => import('../components/general/RootModule.vue'),
        meta: {
            title: 'OrdersModule.module-name',
            icon: 'mdi-cart-outline',
            auth: {
                required: true,
            },
            showInMenu: true,
            moduleRoot: true,
        },
        children: [
            {
                path: '',
                name: RouteNamesEnum.Orders,
                component: () => import('../views/orders-module/OrdersView.vue'),
                meta: {
                    title: 'OrdersModule.orders',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                    isArchive: false,
                },
            },
        ],
    },
];

export default OrdersRoutes;
